const getISODate = (date) => {
  if (!date || Number.isNaN(Date.parse(date))) {
    return date;
  }
  return new Date(date).toISOString();
};

export default getISODate;
